import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Layouts (keep these as regular imports for faster initial render)
import CustomerLayout from "./components/layout/CustomerLayout";

// Loading Fallback Component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
  </div>
);

// ============================================
// LAZY LOADED PAGES
// ============================================

// Customer Pages (lazy loaded)
const LandingPage = lazy(() => import("./pages/customer/LandingPage"));
const MenuPage = lazy(() => import("./pages/customer/MenuPage"));
const CartPage = lazy(() => import("./pages/customer/CartPage"));
const PaymentPage = lazy(() => import("./pages/customer/PaymentPage"));
const OrderStatusPage = lazy(() => import("./pages/customer/OrderStatusPage"));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public Routes (Customer App) */}
          <Route element={<CustomerLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/order" element={<MenuPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/payment/:orderId" element={<PaymentPage />} />
            <Route
              path="/order-status/:orderId"
              element={<OrderStatusPage />}
            />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
